import { t } from 'i18next';
import React from 'react';
import { bool, number, oneOf, string } from 'prop-types';
import cn from 'classnames';
import { add } from 'ionicons/icons';

import CustomButton from '~components/CustomButton';
import { ANALYTICS_CLASSES } from '~constants/analytics';
import { formatPrice } from '~utils/number';
import { giftCardItem } from '~propTypes/giftCard';
import { giftCardHasDiscount } from '~models/giftCard';

import { useGiftCard } from './hooks';
import styles from './styles.module.scss';
import { PRICE_POSITION } from './constants';

function GiftCard({ item, index, showGiftCardDisclaimer, pricePosition, priceClassName, canModifyItem }) {
  const { onModify, onRemove, loading, giftCardsDiscountTitle } = useGiftCard({ item, index });
  const {
    name: giftCardName,
    receiver: { name, email },
    buyingPrice,
    price
  } = item;

  const giftCardPrice = (
    <>
      {giftCardHasDiscount(item) && <span className={styles.badge}>{giftCardsDiscountTitle}</span>}
      <span className={cn(styles.price, priceClassName)}>{formatPrice(buyingPrice || price)}</span>
    </>
  );

  return (
    <div className={styles.container}>
      <div className={styles.rowContainer}>
        <p className={styles.title}>{giftCardName}</p>
        {pricePosition === PRICE_POSITION.TOP && giftCardPrice}
        {canModifyItem && (
          <CustomButton
            className={cn(styles.removeButton, ANALYTICS_CLASSES.cart.btnIncreaseProductQuantity)}
            type="button"
            onClick={onRemove}
            disabled={loading}
            iconStyles={`text-select ${styles.icon}`}
            icon={add}
          />
        )}
      </div>
      <div className={styles.giftCardDetails}>
        <p>
          <span className={styles.bulletDecoration}>{t('GiftCard:to')}</span>
          {name}
        </p>
        <p>({email})</p>
      </div>
      {showGiftCardDisclaimer && (
        <div className={styles.giftCardDisclaimer}>
          <p>
            <span>{t('GiftCard:digitalDelivery')}</span>
            {t('GiftCard:disclaimer')}
          </p>
        </div>
      )}
      <div className={styles.buttonContainer}>
        {canModifyItem && (
          <CustomButton
            text={t('CartVariant:modify')}
            textClassName={styles.modifyButtonLabel}
            type="button"
            onClick={onModify}
            btnClassType="link"
            className={cn(ANALYTICS_CLASSES.cart.btnModifyProduct, styles.modifyButton)}
            textCapitalize
          />
        )}
        {pricePosition === PRICE_POSITION.BOTTOM && giftCardPrice}
      </div>
    </div>
  );
}

GiftCard.propTypes = {
  canModifyItem: bool,
  index: number,
  item: giftCardItem,
  priceClassName: string,
  pricePosition: oneOf(Object.values(PRICE_POSITION)),
  showGiftCardDisclaimer: bool
};

GiftCard.defaultProps = {
  canModifyItem: true,
  priceClassName: '',
  pricePosition: PRICE_POSITION.BOTTOM
};

export default GiftCard;
